import { getUrl, httpGetAuthorized } from "components/utils/http";
import useSWR, { mutate } from "swr";
import { ContactInboundData } from "./types";

export const useApplicationContacts = (
    applicationNumber: string
): [contacts: ContactInboundData[] | undefined, isLoading: boolean, error: any] => {
    const url = applicationNumber ? getUrl(process.env.REACT_APP_APPLICATION_CONTACTS_ENDPOINT2, { applicationNumber }) : null;
    const { data, error, isLoading } = useSWR(url, httpGetAuthorized);

    return [data, isLoading, error];
};

export const refreshApplicationContacts = (applicationNumber: string) => {
    const url = applicationNumber ? getUrl(process.env.REACT_APP_APPLICATION_CONTACTS_ENDPOINT2, { applicationNumber }) : null;
    mutate(url);
};
